export enum MixerActions {
    DELETE = 'delete',
    DELETE_ALL = 'deleteAll',
    TOGGLE_LOCK = 'toggleLock',
    TOGGLE_VISIBLE = 'toggleVisible',
    TOGGLE_TRANSPARENCY = 'toggleTransparency',
    CHANGE_WEIGHT = 'weight',
    RESET_WEIGHT = 'resetWeight',
    TOGGLE_INVERT = 'toggleInvert',
    IS_0_1_NORMALIZATION = 'isRangeNormalization',
}
